import React, { useState, useEffect } from 'react'

const Header = () => {
  const [activeTab, setActiveTab] = useState('hero')
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const scrollToSection = (id) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
      setActiveTab(id)
      setMobileMenuOpen(false) // Close mobile menu after navigation
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
      // Update active tab based on scroll position
      const sections = ['hero', 'about', 'skills', 'projects', 'hire-me', 'contact']
      let current = 'hero'
      for (const section of sections) {
        const el = document.getElementById(section)
        if (el && window.scrollY >= el.offsetTop - 100) {
          current = section
        }
      }
      setActiveTab(current)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'hire-me', label: 'Hire Me' },
    { id: 'contact', label: 'Contact' }
  ]

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-backgroundDark/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
      <nav className="max-w-6xl mx-auto flex justify-between items-center p-4">
        {/* Logo */}
        <div className="font-heading text-xl md:text-2xl font-bold cursor-pointer text-primary hover:text-primaryBright transition-colors duration-300" onClick={() => scrollToSection('hero')}>
          TheAM
        </div>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex space-x-6 font-body font-medium">
          {navItems.map((item) => (
            <li
              key={item.id}
              className={`cursor-pointer transition-all duration-300 ${activeTab === item.id ? 'text-primary border-b-2 border-primary' : 'text-textSecondary hover:text-primary'}`}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1 focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span className={`block w-6 h-0.5 bg-textSecondary transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-textSecondary transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-textSecondary transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`md:hidden absolute top-full left-0 w-full bg-backgroundDark/95 backdrop-blur-sm transition-all duration-300 ${mobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        <ul className="flex flex-col py-4 px-4 space-y-4 font-body font-medium">
          {navItems.map((item) => (
            <li
              key={item.id}
              className={`cursor-pointer transition-all duration-300 py-2 px-4 rounded-lg ${activeTab === item.id ? 'text-primary bg-primary/10 border-l-4 border-primary' : 'text-textSecondary hover:text-primary hover:bg-accent'}`}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </header>
  )
}

export default Header
